// extracted by mini-css-extract-plugin
export default {"table":"Table_table__U6MvI","scrollWrapper":"Table_scrollWrapper__kgzXf"};